module.exports = __webpack_public_path__ + "img/beine-seite-outline-L.af87cb88.png";